import {
   ContextDialog,
   ContextDialogPlacement,
   ContextDialogWidth,
   StyledFlex,
   StyledMargin,
} from '@dreryk/react-components';

import { PreInterviewPreviewItem } from '../../../common/preInterview/PreInterviewPreviewItem';
import { PreInterviewPreviewItemsLoader } from '../../../common/preInterview/PreInterviewPreviewItems.loader';
import { visitDetailsTranslationKeys } from '../../../translations';

import { PreInterviewApprovalDateText } from './PreInterviewApprovalDateText';
import { PreInterviewMarkAsRead } from './PreInterviewMarkAsRead';
import { StyledContextDialog } from './PreInterviewPreviewContextDialog.styled';
import { PreInterviewPreviewContextDialogConfirmButton } from './PreInterviewPreviewContextDialogConfirmButton';

type PreInterviewPreviewContextDialogProps = {
   readonly triggerElement: HTMLElement | null;
   readonly appointmentId: number;
};

export const PreInterviewPreviewContextDialog = (props: PreInterviewPreviewContextDialogProps): JSX.Element => {
   return (
      <StyledContextDialog
         testId={'preInterviewPreview'}
         triggerElement={props.triggerElement}
         placement={ContextDialogPlacement.RIGHT}
         title={visitDetailsTranslationKeys.preInterview.dialog.title}
         width={ContextDialogWidth.NORMAL}
         preventHideOnOutsideClick
      >
         {(hide) => (
            <PreInterviewPreviewItemsLoader appointmentId={props.appointmentId}>
               {({ preInterviewItems, preInterview }) => (
                  <StyledMargin top={2}>
                     <StyledFlex direction={'column'} gap={24}>
                        {preInterviewItems.map((item) => (
                           <PreInterviewPreviewItem
                              key={item.id}
                              questionContent={item.questionContent}
                              questionNumber={item.questionNumber}
                              answerContent={item.answerContent}
                           />
                        ))}
                     </StyledFlex>

                     <StyledMargin top={8} bottom={8}>
                        {preInterview.approvalDate ? (
                           <PreInterviewApprovalDateText approvalDate={preInterview.approvalDate} />
                        ) : null}
                     </StyledMargin>

                     <ContextDialog.FooterElement>
                        <>
                           <PreInterviewPreviewContextDialogConfirmButton
                              hide={hide}
                              preInterviewItems={preInterviewItems}
                           />
                           <ContextDialog.ConfirmButton
                              label={visitDetailsTranslationKeys.preInterview.dialog.actions.confirm}
                              onClick={hide}
                           />

                           <ContextDialog.CloseButton onClick={hide} />
                        </>
                     </ContextDialog.FooterElement>

                     <PreInterviewMarkAsRead preInterview={preInterview} />
                  </StyledMargin>
               )}
            </PreInterviewPreviewItemsLoader>
         )}
      </StyledContextDialog>
   );
};
